import { APP_SERVER_HOST } from '@/constants'
import Api from '@/api'
export function downloadFile (path: string, query: any = {}) {
  console.log(`${APP_SERVER_HOST}${path}?${new URLSearchParams(query)}`)
  return fetch(`${APP_SERVER_HOST}${path}?${new URLSearchParams(query)}`, { headers: { 'Authorization': `Bearer ${Api.getToken()}` } })
  .then(resp => resp.blob())
  .then(blob => {
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.style.display = 'none'
    a.href = url
    a.download = 'report.xlsx'
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(url)
  })
  .catch(() => { })
}
